export default "__VITE_ASSET__CtxqJxC$__"